// 엑셀 다운로드 테이블 공통사항 적용
// 전체 행 넓이값 적용
export async function changeColWidth(worksheet, columns, width) {
  const column = worksheet.getColumn(columns);
  column.width = width;
}

// 전체 열 높이값 적용
export async function changeRowHeight(worksheet, rows, height) {
  const row = worksheet.getRow(rows);
  row.height = height;
}

// 공급자 및 주문자 정보 셀 병합 및 css 함수
export async function createContentAndMerge(
  worksheet,
  contentsArr,
  mergeContentsArr,
  mergeLastContentArr,
  infoArr = null
) {
  // 공급자 및 결제정보 정보 css (단일 칸 / 변수 동일)
  contentsArr.map((content) => {
    createCellWithBorder(worksheet, content[0], content[1]);
  });
  // 공급자 및 구매자, 결제정보 셀 병합 및 css (복수의 칸 / 변수 동일)
  mergeContentsArr.map((content) => {
    createTwoBlock(worksheet, content);
  });
  // 주의사항 css
  if (mergeLastContentArr) {
    mergeLastContentArr.map((content) => {
      createLastContentCss(worksheet, content);
    });
  }
  // 구매자 셀 병합
  if (infoArr) {
    infoArr.map((x) => {
      worksheet.getCell(x[1]).value = x[0];
    });
  }
}

// 공급자 및 구매자, 결제정보 정보 단일 칸 css
export async function createCellWithBorder(worksheet, text, location) {
  worksheet.getCell(location).value = text;
  // 공급자 및 구매자, 결제정보 정보 단일 칸 선 지정
  worksheet.getCell(location).border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };
  // 공급자 및 구매자, 결제정보 정보 단일 칸 정렬
  worksheet.getCell(location).alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  // 공급자 및 구매자, 결제정보 정보 단일 칸 글자크기 지정
  worksheet.getCell(location).font = {
    size: 8,
  };
}

// 공급자 및 구매자, 결제정보 복합 칸 css
export async function createTwoBlock(worksheet, location) {
  worksheet.mergeCells(location);
  // 해공급자 및 구매자, 결제정보 복합 칸  선 지정
  worksheet.getCell(location).border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };
  // 공급자 및 구매자, 결제정보 복합 칸 정렬
  worksheet.getCell(location).alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  // 공급자 및 구매자, 결제정보 복합 칸 글자크기 지정
  worksheet.getCell(location).font = {
    size: 8,
  };
}

// 엑셀 상단 좌측 날짜, 주문인, 주문번호 css
export async function createOrderInfo(worksheet, location) {
  worksheet.getCell(location).border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell(location).alignment = {
    horizontal: "right",
    vertical: "middle",
  };
  worksheet.getCell(location).font = {
    size: 8,
  };
}

// 엑셀 중간 품목 및 브랜드 테이블 css
export async function createAllCell(worksheet, location) {
  // 상품 테이블 칸 정렬
  worksheet.getCell(location).alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  // 상품 테이블 글자크기 지정
  worksheet.getCell(location).font = {
    size: 8,
  };
}

// 엑셀 하단 주의사항 css
export async function createLastContentCss(worksheet, location) {
  // 주의사항 칸 정렬
  worksheet.getCell(location).alignment = {
    horizontal: "left",
    vertical: "middle",
  };
  // 주의사항 글자크기 지정
  worksheet.getCell(location).font = {
    size: 8,
  };
}
